export default {
  'alerts.date': 'Occurrence date',
  'alerts.defect.value': '{defectName}: {value}',
  'alerts.defects': 'Defect values',
  'common.1day': '1 day',
  'common.1hour': '1 hour',
  'common.10minutes': '10 minutes',
  'common.actions': 'Actions',
  'common.add.failure': 'Adding failed',
  'common.add.success': 'Added successfully',
  'common.charts': 'Charts',
  'common.charts.addToReport': 'Add to report',
  'common.close': 'Close',
  'common.count': 'Count',
  'common.createdAt': 'Creation date',
  'common.date': 'Date',
  'common.dateRange': 'Date range',
  'common.dayComparison': 'Day comparison',
  'common.defectSet': 'Defect set',
  'common.defectType': 'Defect type',
  'common.delete': 'Delete',
  'common.delete.failure': 'Deleting failed',
  'common.delete.success': 'Deleted successfully',
  'common.deselect': 'Deselect',
  'common.deselectAll': 'Deselect all',
  'common.device': 'Device',
  'common.devices': 'Devices',
  'common.download': 'Download',
  'common.edit': 'Edit',
  'common.edit.failure': 'Editing failed',
  'common.edit.success': 'Edited successfully',
  'common.email': 'Email',
  'common.email.validation': 'Please enter a valid email address',
  'common.feature': 'Feature',
  'common.fetch.failure': 'Fetching data failed',
  'common.imageAngle': 'Image angle',
  'common.images': 'Images',
  'common.logout': 'Logout',
  'common.name': 'Name',
  'common.no': 'No',
  'common.noDefects': 'No defects',
  'common.percentages': 'Percentages',
  'common.phone': 'Phone',
  'common.pieces': 'Pieces',
  'common.preview': 'Preview',
  'common.reload': 'Reload',
  'common.removeAll': 'Remove all',
  'common.required': 'This field is required',
  'common.reset': 'Reset',
  'common.samples_count': 'Samples count',
  'common.search': 'Search',
  'common.select': 'Select',
  'common.selectedDate': 'Selected date',
  'common.sorting': 'Sorting',
  'common.sorting.ascending': 'Ascending',
  'common.sorting.descending': 'Descending',
  'common.sorting.timestamp.ascending': 'From oldest',
  'common.sorting.timestamp.descending': 'From newest',
  'common.specificName': 'Name: {name}',
  'common.table': 'Table',
  'common.timeline': 'Timeline',
  'common.timeRange': 'Time range',
  'common.units': 'Displayed units',
  'common.update.success': 'Updated successfully',
  'common.upload': 'Upload file',
  'common.yes': 'Yes',
  'dashboard.defectSummary': 'Defect summary',
  'dashboard.detectedDefects': 'Detected defects',
  'dashboard.inspections': 'Inspections',
  'dashboard.latestInspections': 'Latest inspections',
  'dashboard.latestIssues': 'Latest issues',
  'dashboard.nextDay': 'Next day',
  'dashboard.noData': 'No entries for the selected date',
  'dashboard.previousDay': 'Previous day',
  'dashboard.prodErrors': 'Production errors',
  'dashboard.rejectionRate': 'Rejection rate',
  'dashboard.rejectionRate.description': 'Cases of the same type of error occurring three times in a row',
  'dashboard.rejections': 'Rejections',
  'dashboard.successfulInspections': 'Successful inspections',
  'dashboard.summary': 'Summary',
  'dashboard.table.description': 'Description',
  'dashboard.table.socket': 'Socket',
  'dashboard.table.status': 'Status',
  'dashboard.table.timestamp': 'Date',
  'generateReport': 'Generate report',
  'generateReport.addedCharts': 'Charts added to report',
  'generateReport.addImage': 'Image added to report',
  'generateReport.download': 'Download Report',
  'generateReport.duplicateName': 'Report with this name already exists. Please provide a different name.',
  'generateReport.failure': 'Failed to generate report',
  'generateReport.name': 'Report name',
  'generateReport.noSelectedImages': 'No images selected',
  'generateReport.removeImage': 'Image removed from report',
  'generateReport.selectedImages': 'Selected images',
  'generateReport.success': 'Report generated successfully',
  'menu.alerts': 'Alerts',
  'menu.alerts.contacts': 'Contacts',
  'menu.alerts.logs': 'History',
  'menu.dashboard': 'Dashboard',
  'menu.devices': 'Devices',
  'menu.home': 'Home',
  'menu.labels': 'Labels',
  'menu.labelTemplates': 'Label templates',
  'menu.reports': 'Reports',
  'menu.samples': 'Sample analysis',
  'menu.settings': 'Settings',
  'menu.thresholds': 'Defect acceptance thresholds',
  'menu.users': 'Users',
  'page.alerts.addContact': 'Add contact',
  'page.alerts.deleteContact': 'Delete contact',
  'page.alerts.deleteContact.description': 'Are you sure you want to delete this contact?',
  'page.alerts.editContact': 'Edit contact',
  'page.devices.currentDefectSetName': 'Current defect set: <b>{name}</b>',
  'page.devices.supportLabels': 'Supports labels:',
  'page.labels.addLabel': 'Add label',
  'page.labels.deleteLabel': 'Delete label',
  'page.labels.deleteLabel.description': 'Are you sure you want to delete the label?',
  'page.labels.devices': 'Devices',
  'page.labels.editLabel': 'Edit label',
  'page.labels.timestamp': 'Date',
  'page.labelTemplates.addTemplate': 'Add template',
  'page.labelTemplates.applyOnDevice': 'Apply to device',
  'page.labelTemplates.applyOnDevice.alert': 'Please select the device to which the selected label template will be applied',
  'page.labelTemplates.deleteLabelTemplate': 'Delete template',
  'page.labelTemplates.deleteLabelTemplate.description': 'Are you sure you want to delete this template?',
  'page.labelTemplates.deleteLabelTemplate.error': 'The template cannot be deleted because it is used by one or more devices.',
  'page.labelTemplates.devices': 'Supported devices',
  'page.labelTemplates.editTemplate': 'Edit template',
  'page.labelTemplates.features': 'Label values',
  'page.labelTemplates.images': 'Label images',
  'page.reports.cannotDelete': 'You cannot delete another user\'s report.',
  'page.reports.copyLink.failure': 'Failed to copy link',
  'page.reports.copyLink.success': 'Successfully copied link, it will be active for the next 24 hours',
  'page.reports.copyLink.title': 'Copy link',
  'page.reports.delete.description': 'Are you sure you want to delete this report?',
  'page.reports.delete.title': 'Delete report',
  'page.reports.download.failure': 'Failed to download report',
  'page.reports.generatedBy': 'Generated by',
  'page.samples.noSamples': 'No entries for the selected date range',
  'page.settings.complaintThresholdEnabled': 'Enable complaint threshold',
  'page.settings.endTime': 'Shift end time',
  'page.settings.startTime': 'Shift start time',
  'page.thresholds.addThreshold': 'Add threshold',
  'page.thresholds.defect': 'Supported defects',
  'page.thresholds.deleteThreshold': 'Delete threshold',
  'page.thresholds.deleteThreshold.description': 'Are you sure you want to delete this threshold?',
  'page.thresholds.deleteThreshold.error': 'The threshold cannot be deleted because it is used by one or more devices.',
  'page.thresholds.editThreshold': 'Edit threshold',
  'page.thresholds.thresholdName': 'Threshold Name',
  'page.thresholds.values': 'Threshold values',
  'page.thresholds.warning.description': 'Only authorized users who understand how threshold selection works should modify the presented values. <b>They affect the operation of the entire system, not just for one user</b>.\nChanging thresholds has an immediate impact on the data presented on the page and all reports generated after this change. <b>Reports in .pdf files generated earlier will not be changed</b>.',
  'page.thresholds.warning.title': 'Warning!',
  'page.users.addUser': 'Add user',
  'page.users.deleteUser': 'Delete user',
  'page.users.deleteUser.description': 'Are you sure you want to delete the user?',
  'page.users.deleteUser.tooltip': 'You cannot delete your own account',
  'page.users.editUser': 'Edit user',
  'page.users.firstName': 'First name',
  'page.users.lastName': 'Last name',
  'page.users.password': 'Password',
  'page.users.permissions': 'Permissions',
  'pages.403.buttonText': 'Back to home',
  'pages.403.subTitle': 'Sorry, you are not authorized to access this page.',
  'pages.404.buttonText': 'Back to home',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.login.badRequest': 'Invalid login credentials',
  'pages.login.failure': 'Login failed',
  'pages.login.password.placeholder': 'Password',
  'pages.login.subTitle': 'Login',
  'permissions.alerts': 'Alerts',
  'permissions.current_data': 'Current data',
  'permissions.devices': 'Devices',
  'permissions.label_templates': 'Label templates',
  'permissions.labels': 'Labels',
  'permissions.manage_label_templates': 'Manage label templates',
  'permissions.manage_labels': 'Manage labels',
  'permissions.reports': 'Reports',
  'permissions.samples': 'Sample analysis',
  'permissions.settings': 'Settings',
  'permissions.system_status': 'System status',
  'permissions.thresholds': 'Defect acceptance thresholds',
  'permissions.uploads': 'File uploads',
  'permissions.users': 'Users',
  'placeholder.select.multiple': 'Select multiple',
  'threshold.complaint': 'Complaint threshold',
  'threshold.production': 'Production threshold',
  'unauthorized.description': 'Please log in again to continue.',
  'unauthorized.title': 'Your session has expired',
};
